import { DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DELETE } from '../../DocFlowSending'

export function isDeleteMssAction(action) {
  return action === DOC_FLOW_SENDING_COMMUNICATION_TABLE_MASS_ACTION_DELETE
}
